export default class RichMenuImplantation {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.implantations = document.querySelectorAll(".js-item-implantation");
        this.ui.linkWithChildren = document.querySelectorAll(".js-item-implantation.has-children");
        this.ui.linkWithRightbox= document.querySelectorAll(".js-item-implantation.has-right-box");
        this.ui.subImplantations = document.querySelectorAll(".header__rich__right--implantations");
        this.ui.headerRight = document.querySelectorAll(".header__rich__right:not(.js-header-right-alt)");
        this.ui.headerRightFromItems = document.querySelectorAll(".js-header-right-alt");
        this.ui.$navRichMenus = document.querySelectorAll('.js-nav-rich-menu');
    }

    bindEvents() {
        var minH = 0;
        [].forEach.call(this.ui.implantations, (item, index) => {
            item.addEventListener("mouseover", this.hideChildrens.bind(this,item));
            item.addEventListener("mouseover", this.displaySubImplantations.bind(this,item));

            const subSubmenu = item.querySelectorAll('.nav__item__sub');
            if( subSubmenu ) {
                subSubmenu.forEach((el) => {
                    let elH = this.getHeight(el);
                    if( elH > minH ) {
                        minH = elH;
                        item.parentNode.style.minHeight = minH + "px";
                    }
                })
            }
        });

        this.ui.$navRichMenus[2].addEventListener("mouseleave", this.hideSubImplantations.bind(this));

        [].forEach.call(this.ui.linkWithChildren, (item, index) => {
            item.addEventListener("mouseover", this.showChildrens.bind(this,item));
        });

    }

    displaySubImplantations(item){
        const dataImp = item.dataset.implantation;
        [].forEach.call(this.ui.subImplantations, (item2, index) => {
            const dataSubImp = item2.dataset.implantation;

            if (dataImp === dataSubImp) {
                item2.classList.add("is-active")
            } else {
                item2.classList.remove("is-active")
            }
        });
        if(item.classList.contains('has-right-box')){
            let currBoxRight = document.querySelector(".js-header-right-alt[data-implantation-target='"+item.getAttribute('data-implantation')+"']");
            currBoxRight.style.display = 'block';
        }
    }

    hideSubImplantations() {
        [].forEach.call(this.ui.subImplantations, (item2, index) => {
            const dataSubImp = item2.dataset.implantation;
            setTimeout(()=>{
                item2.classList.remove("is-active")
            }, 300);

        });
    }

    showChildrens(item){
        [].forEach.call(this.ui.headerRight, (el, index) => {
            el.style.display = 'none';
        });
        item.classList.add('is-hovered');
    }

    hideChildrens(item){
        [].forEach.call(this.ui.headerRightFromItems, (el, index) => {
            el.style.display = 'none';
        });
        [].forEach.call(this.ui.headerRight, (el, index) => {
            el.style.display = 'block';
        });
        [].forEach.call(this.ui.linkWithChildren, (el, index) => {
            el.classList.remove('is-hovered');
        });
    }

    getHeight(el) {
        var wanted_height = 0;

        el.style.position   = 'absolute';
        el.style.visibility = 'hidden';
        el.style.display    = 'block';

        wanted_height     = el.offsetHeight;

        el.style    = {};

        return wanted_height;
    }

}
